import ConfigView        from 'scripts/defa/basic/view-config-view';
import Forecasts         from 'scripts/defa/weather/collection-forecasts';
import FullForecastView  from 'scripts/defa/weather/view-full-forecast-view';
import ForecastTodayView from 'scripts/defa/weather/view-forecast-today-view';
import Forecast          from 'scripts/defa/weather/model-forecast';
import ControlModule     from 'scripts/poppet/control-module';
import template          from 'templates/controlWeather.jst.html';

/**
 * defa.views.ControlWeatherView
 * A control module for unit weather.
 * @version 1.3.0
 */

const selectors = {
	toggleButton      : '[data-toggle=expand-spoiler]',
	regionSticky      : '[data-region=weather-sticky]',
	regionContainer   : '[data-region=weather-container]',
};

const ControlWeatherView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState   : 'unit:control:weather',
	compressedNavState : 'unit:control:overview',

	
	className: function () {
		return this._getClassName( 'control-weather' );
	},
	
	ui: {
		toggle : selectors.toggleButton,
	},
	
	events: {
		'click @ui.toggle'      : 'onClickToggle',
	},
	
	regions: {
		sticky   : selectors.regionSticky,
		container: selectors.regionContainer,
	},

	templateContext: function () {
		const superContext = ControlModule.prototype.templateContext.call(this);
		return _.extend( superContext, {
			location: this.collection.location.name,
		}); 
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	onClickToggle: function ( event ) {
		event.preventDefault();
		this._hideTodayForecast( this.ui.toggle.hasClass( 'open' ) );
		ControlModule.prototype.onClickToggle.call( this, event );
	},


	/**
	 * Draws current weather to the weather module.
	 * @void
	 */
	onRender: function () {
		// this._showWeather();
		this._hideTodayForecast( this.options.state === 'open' );
		this.$el.find('#weather-url').attr("href", this.collection.weatherUrl);
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------


	_showWeather() {
		this._showTodayForecast();
		this._showFullForecast();
	},

	/**
	 * Displays today's weather as four icons.
	 * @private
	 * @void
	 */
	_showTodayForecast: function () {		
		// show today's weather above the fold
		let today = new Date().getDate();
		let todayForecasts = this.collection.filter(function(forecast){
			let date = forecast.getDate();
			return date == today;
		});
		let todayForecast = new FullForecastView( {
			collection: new Forecasts(todayForecasts),
			paddle    : false
		} );
		this.showChildView( 'sticky', todayForecast );
	},

	_showFullForecast: function() {
		let fullForecast = new FullForecastView({
			collection: this.collection,
			paddle    : true
		});
		this.showChildView('container', fullForecast);
	},

	_hideTodayForecast: function( hide ) {
		if ( hide ) {
			// this.getRegion('sticky').$el.hide();
			this.getRegion('sticky').empty();
			this._showFullForecast()
		} else {
			this.getRegion('container').empty();
			this._showTodayForecast();
			
			// this.getRegion('sticky').$el.show();
		}
	},

} );

export default ControlWeatherView;